import styled, { css } from 'styled-components';
import { theme } from '../../styles/theme';
import { IDefaultButtonProps } from './types';
import DefaultButton from './DefaultButton';

const PrimaryButton = styled(DefaultButton)<IDefaultButtonProps>`
  ${({ isOutlined }) =>
    isOutlined
      ? css`
          --button-text-c: ${theme.colors.mainBlue};
          --button-text-hover-c: ${theme.colors.mainBlue};
        `
      : css`
          --button-bg-c: ${theme.colors.mainBlue};
          --button-text-c: ${theme.colors.inverse};
          --button-text-hover-c: ${theme.colors.inverse};
          --button-bg-hover-c: #005ab2;
          body.dark & {
            --button-bg-hover-c: #2985fa;
          }
        `}
`;

export default PrimaryButton;
